import React from 'react'

import { Button, Tile, TileCaption } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'

import Image from 'components/LegacyImage'
import Link from 'components/Link'
import { CourseMeta, OutcomeContent } from 'types/data'

export const CourseInstructorTile = ({
  content,
  courseMeta,
  isPrioritized,
  onClick,
}: {
  content: OutcomeContent
  courseMeta: CourseMeta
  isPrioritized: boolean
  onClick: () => void
}) => {
  const { t } = useTranslation('@mc/next')

  return (
    <Tile>
      <TileCaption position='right bottom' padding={4}>
        <Button
          as={Link}
          href={paths.courseTypePage(
            courseMeta.contentType,
            courseMeta.courseSlug,
          )}
          onClick={onClick}
          kind='play'
          size='small'
        >
          {t('outcomePage.tile.classInfoPill.viewClass')}
        </Button>
      </TileCaption>
      <Image
        className='mc-corners--3'
        src={content.tileImgSrc}
        alt=''
        priority={isPrioritized}
        width={588}
        height={333}
        objectFit='cover'
      />
    </Tile>
  )
}
